import access from './@access'
import account from './@account'
import sidebar from './sidebar'
import products from './@products'
import prompt from './prompt'
import common from './common'
import repositories from './@repositories';
import parcel from './@parcel'
import document from './@document'
import configuration from './@configuration'
import report from './@report'
import layout from './layout'


export default {
  [`@access`]: access,
  [`@account`]: account,
  [`sidebar`]: sidebar,
  [`@products`]: products,
  [`prompt`]: prompt,
  [`common`]: common,
  [`@repositories`]: repositories,
  [`@parcel`]: parcel,
  [`@document`]: document,
  [`@configuration`]: configuration,
  [`@report`]: report,
  [`layout`]: layout,
};